import React, { memo } from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { headtrack, headtrackAlumBifold } from "./defaults";
import { RowLayout } from "../../util/accordianStyles";
import useHeadTrackSelector from "./useHeadTrackSelector";

function HeadTrackColorAccordian() {
  const { handleClick, variant, checkMark, isAlumBifold } =
    useHeadTrackSelector();

  return (
    <ReusableAccordian
      accordionName="headTrack"
      heading="Head Track Color"
      secondaryHeading="Select head track color"
    >
      <RowLayout>
        {isAlumBifold
          ? headtrackAlumBifold.map((state) => (
              <div key={state.id} onClick={() => handleClick(state.label)}>
                <Choices
                  label={state.label}
                  variant={variant(state.label)}
                  checkMark={checkMark(state.label)}
                  wide={true}
                />
              </div>
            ))
          : headtrack.map((state) => (
              <div key={state.id} onClick={() => handleClick(state.label)}>
                <Choices
                  label={state.label}
                  variant={variant(state.label)}
                  checkMark={checkMark(state.label)}
                  wide={true}
                />
              </div>
            ))}
      </RowLayout>
    </ReusableAccordian>
  );
}

export default memo(HeadTrackColorAccordian);
